import './AccountSettings.css';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { useEffect, useState,useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import Papa from 'papaparse';

function AccountSettings() {
    const ref = useRef();
    const dispatch = useDispatch();
    //ill have to create some code for this...

    // get the client reducer
    const clients = useSelector((store) => store.clientReducer);

    // get the user information
    const user = useSelector((store) => store.user);


    // state to hold information to register a new user
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPassword2, setNewPassword2] = useState('');
    const [importClientData, setImportClientData] = useState([]);
    
    const errors = useSelector((store) => store.errors);
    const handleImportCSV = () => {
        console.log("file import");
       
        Papa.parse(document.getElementById('upload-csv').files[0],{
            download: true,
            header: false,
            complete: function(results){ 
                        results.data.map((data,index) => {
                            console.log(data);
                            let arr_household_member = [data[13]];
                            console.log(arr_household_member);
                            dispatch({
                                type:"IMPORT_CSV_DATA",
                                payload:{
                                    name: data[0],
                                    email: data[1],
                                    phone: data[2],
                                    phone_type: Number(data[3]),
                                    address: data[4],
                                    dob: Number(data[5]),
                                    gender: Number(data[6]),
                                    race: Number(data[7]),
                                    marital_status: Number(data[8]),
                                    education : Number(data[9]),
                                    veteran: Number(data[10]),
                                    ability: Number(data[11]),
                                    household_head: data[12],
                                    household_members: arr_household_member,
                                    monthly_income: data[14],
                                    reason: Number(data[15]),
                                    reason_text: data[16],
                                    clientNewsLetter: data[17],
                                    //goes to staff
                                    staffName: data[18],
                                    staffEmail: data[19],
                                    requestedItems: data[20],
                                    referralPartnerId: Number(data[21]),
                                    clientStatus: Number(data[22])
                                    

                                }
                            })
                        })
            }
        })
         ref.current.value = "";
    }


    const changePassword = () => {

        const payload = {
            user: Number(user.id),
            password: newPassword,
        }

        dispatch({ type: 'CHANGE_PASSWORD', payload: payload });
        alert("Password changed successfully! Please login with new password.");
        dispatch({ type: 'LOGOUT' });
    }

    // function to register a new user
    const registerUser = (event) => {
        event.preventDefault();

        dispatch({
            type: 'REGISTER',
            payload: {
                username: username,
                password: password,
            },
        });
    }; // end registerUser

    // const accountSettings = useSelector(store => store.accountSettings);

    useEffect(() => {
        dispatch({ type: 'FETCH_CLIENTS' });
        //dispatch({ type: 'FETCH_EMAIL_SETTINGS' });
    }, []);

    // set the headers for the csv export
    const headers = [
        { label: 'Id', key: 'id' },
        { label: 'Name', key: 'name' },
        { label: 'Email', key: 'email' },
        { label: 'Phone', key: 'phone' },
        { label: 'Phone Type', key: 'phone_type' },
        { label: 'Address', key: 'address' },
        { label: 'D.O.B.', key: 'dob' },
        { label: 'Gender', key: 'gender' },
        { label: 'Primary Race', key: 'race' },
        { label: 'Marital Status', key: 'marital_status' },
        { label: 'Education', key: 'education' },
        { label: 'Veteran', key: 'veteran' },
        { label: 'Ability', key: 'ability' },
        { label: 'Household Head', key: 'househould_head' },
        { label: 'Household Members', key: 'household_members' },
        { label: 'Monthly Income', key: 'monthly_income' },
        { label: 'Reason', key: 'reason' },
        { label: 'Reason Text', key: 'reason_text' },
        { label: 'Children Number', key: 'children_number' },
        { label: 'Notes', key: 'notes' },
        { label: 'Status', key: 'status' },
        { label: 'Staff Name', key: 'staff_name' },
        { label: 'Staff Email', key: 'staff_email' },
        { label: 'Referral Date', key: 'referral_date' },
        { label: 'Referral Partner', key: 'referral_partner_name' },
        { label: 'Referral Partner Phone Number', key: 'referral_partner_phone' },
    ]

    const csvReport = {
        filename: 'Client_info.csv',
        headers: headers,
        data: clients,
    }

    const closedClients = clients.filter(c => c.status === 2);

    const closedCsvReport = {
        filename: 'Closed_Client_info.csv',
        headers: headers,
        data: closedClients,
    }

        
    return (
        <>

            <Table striped bordered hover>
                <tbody >
                    {/* <tr >
                        <th colSpan="2" width="15%">
                            <Button variant="outline-primary" size="sm">Edit</Button>{' '}
                        </th>
                    </tr> */}
                    <tr>
                        <td width="15%" className="d-flex-inline align-middle text-center">
                            Change Password
                        </td>
                        <td className=" d-flex-inline align-middle text-left">
                            <form id='user-form' onSubmit={changePassword}>
                                {errors.registrationMessage && (
                                    <h3 className="alert" role="alert">
                                        {errors.registrationMessage}
                                    </h3>
                                )}
                                <label htmlFor="newPassword">
                                    New Password:
                                    <div className="form-group mr-3">
                                        <input type="password" name="newPassword" value={newPassword} required onChange={(event) => setNewPassword(event.target.value)} />
                                    </div>
                                </label>
                                <label htmlFor="newPassword2">
                                    Verify Password:
                                    <div className="form-group mx-3">
                                        <input type="password" name="newPassword2" value={newPassword2} required onChange={(event) => setNewPassword2(event.target.value)} />
                                    </div>
                                </label>
                                {(newPassword) ?
                                    <>
                                        {(newPassword === newPassword2) ? <Button className="ml-5" variant='outline-primary' value={newPassword} onClick={changePassword}>Change Password</Button> : <>Passwords do not match!</>}
                                    </> : <>Please Enter a New Password</>}
                            </form>
                        </td>
                    </tr>
                    <tr>
                        <td width="15%" className=" d-flex-inline align-middle text-center">
                            Add New User
                        </td>
                        <td className=" d-flex-inline align-middle text-left">
                            <form id='user-form' onSubmit={registerUser}>
                                {errors.registrationMessage && (
                                    <h3 className="alert" role="alert">
                                        {errors.registrationMessage}
                                    </h3>
                                )}
                                <label htmlFor="username">
                                    Username:
                                    <div className="form-group mr-3">
                                        <input type="text" name="username" value={username} required onChange={(event) => setUsername(event.target.value)} />
                                    </div>
                                </label>
                                <label htmlFor="password">
                                    Password:
                                    <div className="form-group mx-3">
                                        <input type="password" name="password" value={password} required onChange={(event) => setPassword(event.target.value)} />
                                    </div>
                                </label>
                                <label htmlFor="password2">
                                    Verify Password:
                                    <div className="form-group mx-3">
                                        <input type="password" name="password2" value={password2} required onChange={(event) => setPassword2(event.target.value)} />
                                    </div>
                                </label>
                                {(password) ?
                                    <>
                                        {(password === password2) ? <Button className="ml-5" variant='outline-primary' type="submit" name="submit" value="Register">Register User</Button> : <>Passwords do not match!</>}
                                    </>
                                    : <>Please Enter User Information</>}
                            </form>
                        </td>
                    </tr>
                    <tr>
                        <td className=" d-flex-inline align-middle text-center">
                            Export All Client Data
                        </td>
                        <td>
                            <Button variant="outline-primary" id="csv"><CSVLink {...csvReport}  >Export</CSVLink></Button>
                        </td>
                    </tr>
                    <tr>
                        <td className=" d-flex-inline align-middle text-center">
                            Export Closed Client Data
                        </td>
                        <td>
                            <Button variant="outline-primary"><CSVLink {...closedCsvReport}>Export</CSVLink></Button>
                        </td>
                    </tr>
                    <tr>
                        <td className=" d-flex-inline align-middle text-center">
                            Import Client Data
                        </td>
                        <td>
                                <input type="file" id="upload-csv" ref={ref} ></input>
                                    <Button variant="outline-primary" onClick={()=> handleImportCSV()}>Import</Button>
                        </td>
                    </tr>                    
                </tbody>
            </Table>
        </>
    );
}

export default AccountSettings;